import { render } from "./CustomerForm.vue?vue&type=template&id=03e3b6a5&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"

import "./CustomerForm.vue?vue&type=style&index=0&id=03e3b6a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e3b6a5"]])

export default __exports__